import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <div data-testid="terms-page" className="min-h-screen pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-black tracking-tight mb-8">
            TERMS OF <span className="text-primary">SERVICE</span>
          </h1>
          
          <p className="text-muted-foreground mb-8">
            Last updated: December 2025
          </p>

          <div className="space-y-8 text-muted-foreground">
            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the GreenSmart Ltd. website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">2. Services Description</h2>
              <p>
                GreenSmart Ltd. provides smart building solutions, HVAC systems, energy management services, and related consulting. Our services include but are not limited to energy assessments, system installation, maintenance, and monitoring services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">3. User Responsibilities</h2>
              <p className="mb-4">By using our services, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use our services only for lawful purposes</li>
                <li>Not interfere with or disrupt our services</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">4. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, images, and software, is the property of GreenSmart Ltd. and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">5. Energy Savings Disclaimer</h2>
              <p>
                Energy savings estimates provided through our calculator and consultations are based on typical conditions and may vary based on building-specific factors, usage patterns, and external conditions. Actual results may differ from projections. GreenSmart Ltd. does not guarantee specific energy savings amounts.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">6. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, GreenSmart Ltd. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">7. Warranty Disclaimer</h2>
              <p>
                Our services are provided "as is" without warranties of any kind, either express or implied. We do not warrant that our services will be uninterrupted, error-free, or completely secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">8. Governing Law</h2>
              <p>
                These Terms of Service shall be governed by and construed in accordance with the laws of British Columbia, Canada, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">9. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of our services constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">10. Contact Information</h2>
              <p>
                For questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 p-6 glass">
                <p><strong className="text-foreground">GreenSmart Ltd.</strong></p>
                <p>Email: info@greensmart.ltd</p>
                <p>Phone: (778) 729-2202</p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
